import Vue from 'vue'
import Vuex from 'vuex'
import search from './search'; // 搜索页面 状态管理
import Api from '@/utils/api';
import LocalStore from '@/utils/localStore';
import setDocomentTitle from '@/utils/setDocomentTitle'; // 微信端设置DocomentTitle
Vue.use(Vuex);

const state = {
    shopInfo: {
        _id: "",
        logo: "",
        name: "",
        cname: "",
        domain: "",
    },
    userInfo: {
        _id: "",
        headimgurl: "",
        nickname: ""
    },
    // 首页底部tab
    isTab: true,
    // 加载提示
    isLoading: false,
    // 详情页立即购买弹出层
    shoppPopup: false,
    // 详情 点击加入购物车 或者 点击立即下单
    shoppOpenType: "",
    // 首页滚动条
    homeScrollTop: 0,
    scrollTop: 0,
    // 是否登录
    isLogin: false,
    bodyPaddBtm: ".95rem",
    // 底部tab显示购物车数量
    cartCount: 0,
    // 地址发生变化
    addressChang: "",
    toast: {
        show: false,
        text: "",
        type: 'text',
        position: 'middle',
        width: "4rem"
    },
    loginInfo: {
        securitytoken: "",
        shop_id: 336,
        user_id: "",
    },
    // 下单页 addr_id
    addr_id: "",
    // 存放订单数量状态
    orderNum: {
        nuconfirm: 0,
        nudelivery: 0,
        nupay: 0,
        unrate: 0
    },
    isWx: navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1,
    addressDate: {}, // 存放 一元夺酒切换地址 的信息
    isDownLoad: false,
    addressList: "1", // 收获地址长度
    classifyAnimate: {
        x: "",
        y: "",
        headPic: "",
        random: "",
        item_id: "",
        sku_id: ""
    }
};

const mutations = {
    showIsTab: state => state.isTab = true,
    hideIsTab: state => state.isTab = false,
    showIsLoading: state => state.isLoading = true,
    hideIsLoading: state => state.isLoading = false,
    showBodyPaddBtm: state => state.bodyPaddBtm = "0.95rem",
    hideBodyPaddBtm: state => state.bodyPaddBtm = "0",
    updateShoppPopup(state, payload) {
        state.shoppPopup = payload.isTrue;
        state.shoppOpenType = payload.shoppOpenType;
    },
    updateHomeScrollTop(state, payload) {
        state.homeScrollTop = payload.top;
    },
    updateToast(state, payload) {
        state.toast = Object.assign(state.toast, payload);
    },
    updateCartCount(state, payload) {
        // console.error(payload);
        state.cartCount = payload;
    },
    updateAddressChang(state, payload) {
        state.addressChang = payload;
    },
    updateAddrId(state, payload) {
        state.addr_id = payload;
    },
    updateOrderNum(state, payload) {
        state.orderNum = payload;
    },
    updateAddressDate(state, payload) {
        state.addressDate = payload;
    },
    updateLogin(state, payload) {
        state.isLogin = payload;
    },
    updateLoginDate(state, payload) {
        state.loginInfo = payload;
    },
    updateUserInfo(state, payload) {
        state.userInfo = payload;
    },
    updateDownLoad(state, payload) {
        state.isDownLoad = payload;
    },
    updateAddressList(state, payload) {
        state.addressList = payload;
    },
    updateShopInfo(state, payload) {
        state.shopInfo = payload;
        setDocomentTitle(payload.name)
    },
    updateScrollTop(state, payload) {
        state.scrollTop = payload;
    },
    updateClassifyAnimate(state, payload) {
        console.log(payload);
        state.classifyAnimate = payload;
    }
};

const actions =  {
    loadShopInfo({ commit }) {
        return Api.getShopInfo()
            .then(resp => {
                if (resp && resp.data) {
                    LocalStore.setShop(resp.data)
                    commit('updateShopInfo', resp.data)
                }
            })
    },
    loadUserInfo({ commit }) {
        return Api.getUserInfo()
            .then(resp => {
                if (resp && resp.data) {
                    LocalStore.setUser(resp.data)
                    commit('updateUserInfo', resp.data)
                }
            })
    }
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    modules: {
        search
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js